import styled from 'styled-components';

export const Container = styled.div`
  width: 75%;
  margin: 0 auto 40px auto;
  padding: 20px;
  border-radius: 3px;
  background-color: #f5d4d4;
  border: solid 0.5px #cc0000;

  strong {
    margin-right: 8px;
  }
  p {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.63;
    letter-spacing: 0.01px;
    margin-bottom: 15px;
    /* margin-top: 25px; */
    color: #cc0000;
    text-align: center;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin: 8px 0;
    padding-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
  }

  .iconException {
    margin-right: 8px;
    width: 25px;
    margin-top: 2px;
  }

  .exceptionsBoxContent {
    display: flex;
    flex-direction: row;
    align-items: center;

    width: 100%;
  }
`;
